import csatKeys from '@/constants/configuration/csat-keys.json';
import { getEnvAndDex } from '@/utils/get-env-and-dex';
import { PropTypes } from 'prop-types';

const Csat = ({ userId, email }) => {

    // CSAT Integration
    const { env } = getEnvAndDex();
    const csatWidgetBaseUrl = csatKeys[env]?.CSAT_WIDGET_BASE_URL;
    const csatSpaceKey = csatKeys[env]?.CSAT_SPACE_KEY;

    const userSnapLoadFunctionName = `${userId && email ? "onUserSnapLoadLoggedIn" : "onUserSnapLoad"}`;

    if (csatSpaceKey && csatWidgetBaseUrl) {
        // CSAT initialization
        window[`${userSnapLoadFunctionName}`] = function (api) {
            api.init({
                user: {
                    userId: userId,
                    email: email
                }
            });
        }
        // CSAT keys are available so load the script

        // check if the same script is already loaded or not
        if (!document.querySelector(`script[src="${csatWidgetBaseUrl}${csatSpaceKey}?onload=${userSnapLoadFunctionName}"]`)) {
            let script = document.createElement('script');
            script.defer = 1;
            script.src = `${csatWidgetBaseUrl}${csatSpaceKey}?onload=${userSnapLoadFunctionName}`;
            document.getElementsByTagName('head')[0].appendChild(script);
        }
    }
    else if (document.querySelector(`script[src="${csatWidgetBaseUrl}${csatSpaceKey}?onload=${userSnapLoadFunctionName}"]`)) {
        // CSAT keys are not available so remove the script if it is already loaded
        document.querySelector(`script[src="${csatWidgetBaseUrl}${csatSpaceKey}?onload=${userSnapLoadFunctionName}"]`).remove();
    }

    return (<></>);
}

Csat.propTypes = {
    userId: PropTypes.string,
    email: PropTypes.string
}

export { Csat };
